// salesTrendReport.slice.js
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  data: {
    business: null,
    sales: [],
    groupedSales: [],
  },
  loading: false,
  error: null,
};

const salesTrendReportSlice = createSlice({
  name: "salesTrendReport",
  initialState,
  reducers: {
    salesTrendReportRequest(state) {
      state.loading = true;
      state.error = null;
    },
    salesTrendReportSuccess(state, action) {
      state.loading = false;
      state.data = action.payload;
    },
    salesTrendReportFailure(state, action) {
      state.loading = false;
      state.error = action.payload;
    },
    resetSalesTrendReport(state) {
      state.loading = false;
      state.error = null;
      state.data = initialState.data;
    },
  },
});

export const {
  salesTrendReportRequest,
  salesTrendReportSuccess,
  salesTrendReportFailure,
  resetSalesTrendReport,
} = salesTrendReportSlice.actions;

export default salesTrendReportSlice.reducer;
